import { useSelector } from 'react-redux';
import { get } from 'lodash';

export const useIsAuthenticated = () =>
    useSelector((state) => {
        const userId = get(state, 'login.user.id');

        return !!userId || false;
    });
